<template>
    <div id="cardDetails">
        <div class="section1">
            <el-form :inline="true" ref="cardDetailsForm" @submit.native.prevent :model="cardDetailsForm"
                :rules="cardDetailsRules">
                <el-form-item prop="iccid">
                    <el-input v-model.trim="cardDetailsForm.iccid"
                        @keyup.enter.native="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)" placeholder="请输入卡号"
                        v-focus clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain
                        @click="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)">搜索</el-button>
                    <el-button type="primary" size="mini" @click="updateStateHandler(cardInfo.iccid, true)"
                        v-if="showDetail">刷新</el-button>
                </el-form-item>
            </el-form>
        </div>
        <template v-if="showDetail">
            <div class="section2">
                <h4>基本信息</h4>
                <el-row>
                    <el-col :span="3">
                        <img v-if="cardInfo.supplierTypeCode == 3" style="width:120px"
                            src="./../../assets/img_yidong.png" alt="">
                        <img v-if="cardInfo.supplierTypeCode == 4" style="width:120px"
                            src="./../../assets/img_liantong.png" alt="">
                        <img v-if="cardInfo.supplierTypeCode == 1 || cardInfo.supplierTypeCode == 5" style="width:120px"
                            src="./../../assets/img_dianxin.png" alt="">
                    </el-col>
                    <el-col :span="21">
                        <el-row>
                            <el-col :span="24">
                                <el-button type="primary" size="mini" @click="colorShow = true">进行标记</el-button>
                                <el-button type="primary" size="mini" @click="toBuildSim(2)">取消标记</el-button>
                            </el-col>
                            <el-col :span="6">ICCID号：
                                <el-tooltip effect="dark" content="点击查看套餐使用详情" placement="top">
                                    <a href="javascript:void(0);" @click="toFluxPollDetail(cardInfo.iccid)">{{
                                        cardInfo.iccid
                                        }}</a>
                                </el-tooltip>
                                <span @click="copyOrderId()" class="copy_url" :data-clipboard-text="cardInfo.iccid"
                                    style="color: #409EFF;padding-left: 20px;cursor: pointer;">复制</span>
                            </el-col>
                            <el-col :span="6"
                                v-if="cardInfo.supplierName && cardInfo.supplierName.indexOf('运城') == 0 && cardInfo.cardState == 11">
                                <span style="font-size: 28px; color: red;"> 供应商： {{ cardInfo.supplierName }}</span>
                            </el-col>
                            <el-col :span="6" v-else>供应商： {{ cardInfo.supplierName }}</el-col>
                            <el-col :span="6">通道： {{ cardInfo.alias }}</el-col>
                            <el-col :span="6">套餐组： {{ cardInfo.basePkgGroupName }}</el-col>

                            <el-col :span="6">接入号： {{ cardInfo.intoNo }}</el-col>
                            <el-col :span="6">卡代理商归属： {{ cardInfo.agentPathNames }}</el-col>

                            <el-col :span="6">是否限速： {{ cardInfo.limitStateName }}</el-col>
                            <el-col :span="6">卡余额： {{ cardInfo.simAmount }}</el-col>
                            <el-col :span="6">
                                卡状态：
                                <template
                                    v-if="cardInfo.supplierName && cardInfo.supplierName.indexOf('运城') == 0 && cardInfo.cardState == 11">
                                    <el-tag type="danger">{{ cardInfo.cardStateName }}</el-tag>
                                </template>
                                <template v-else>
                                    <el-tag type="warning" v-if="cardInfo.cardState == 1">{{ cardInfo.cardStateName
                                        }}</el-tag>
                                    <el-tag v-else-if="cardInfo.cardState == 2">{{ cardInfo.cardStateName }}</el-tag>
                                    <el-tag type="danger" v-else-if="cardInfo.cardState == 4">{{ cardInfo.cardStateName
                                        }}</el-tag>
                                    <el-tag type="info" v-else>{{ cardInfo.cardStateName }}</el-tag>
                                </template>
                            </el-col>
                            <el-col :span="6">
                                数据状态：
                                <template>
                                    <el-tag type="danger" v-if="cardInfo.dataState == '关闭'">{{ cardInfo.dataState
                                        }}</el-tag>
                                    <el-tag type="info" v-else>{{ cardInfo.dataState }}</el-tag>
                                </template>
                            </el-col>

                            <el-col :span="6" v-if="cardInfo.isDown == 3 && cardInfo.noUseName != '无冻结信息'">
                                冻结状态： <el-tag type="danger">{{ cardInfo.noUseName }} </el-tag>
                            </el-col>
                            <el-col :span="6" v-else-if="cardInfo.isDown == 3">
                                冻结状态： <el-tag type="info">{{ cardInfo.noUseName }} </el-tag>
                            </el-col>
                            <el-col :span="6" v-else-if="cardInfo.isDown == 7">
                                冻结状态： <el-tag type="danger">{{ cardInfo.noUseName }} </el-tag>
                            </el-col>

                            <el-col :span="6" v-if="cardInfo.stopOut == '套餐到期停机'">
                                无次月停机： <el-tag type="info">{{ cardInfo.stopOut }} </el-tag>
                            </el-col>
                            <el-col :span="6" v-else>
                                无次月停机： <el-tag type="danger">{{ cardInfo.stopOut }} </el-tag>
                            </el-col>

                            <el-col :span="6" v-if="cardInfo.dataOut == '套餐用完停机'">
                                流量提前停机： <el-tag type="info">{{ cardInfo.dataOut }} </el-tag>
                            </el-col>
                            <el-col :span="6" v-else>
                                流量提前停机： <el-tag type="danger">{{ cardInfo.dataOut }} </el-tag>
                            </el-col>
                            <el-col :span="6">
                                超套流量： <el-tag type="danger">{{ cardInfo.sumOutData }} /GB </el-tag>
                            </el-col>
                            <el-col :span="6">
                                月限额： <el-tag type="danger">{{ cardInfo.limitUse }} /GB </el-tag>
                            </el-col>



                            <el-col :span="6">
                                在用虚量： <el-tag type="danger">{{ cardInfo.xuName }} </el-tag>
                            </el-col>
                            <el-col :span="6">单卡虚量： {{ cardInfo.flowRatePercent }} %</el-col>
                            <el-col :span="6">变更卡状态备注：
                                <el-tag type="danger"
                                    v-if="cardInfo.supplierName && cardInfo.supplierName.indexOf('运城') == 0 && cardInfo.cardState == 11">{{
                                        cardInfo.changeStateRemark }}</el-tag>
                                <el-tag v-else>{{ cardInfo.changeStateRemark || '--' }}</el-tag>
                            </el-col>
                            <el-col :span="6">用户姓名： {{ cardInfo.userName }}</el-col>
                            <el-col :span="6">绑定手机号： {{ cardInfo.userPhone }}</el-col>
                            <el-col :span="6">用户地址： <el-tag type="danger" style="font-weight:bold">{{ cardInfo.userCity
                                    }}
                                </el-tag></el-col>
                            <el-col :span="6">手机绑定次数： {{ cardInfo.userPhoneCount }}</el-col>
                            <el-col :span="6">身份证绑定次数： {{ cardInfo.idCardCount }}</el-col>
                            <el-col :span="6">身份证秒反次数： {{ cardInfo.idCardBuildCount }}</el-col>
                            <el-col :span="6"> 标记状态： <el-tag type="success">{{ cardInfo.isBuild == 1 ? '已标记' :
                                '未标记' }}</el-tag> </el-col>
                            <el-col :span="6">VIP充值： {{ cardInfo.vipName }}</el-col>
                            <el-col :span="6">VIP到期： {{ cardInfo.vipTime }}</el-col>

                            <el-col :span="6">虚拟号：
                                <template v-if="!isEdit">{{ cardInfo.virtualNo }}
                                    <el-button style="margin-left: 5px; " size="mini"
                                        @click="isEdit = true">修改虚拟号</el-button>
                                </template>
                                <template v-if="isEdit">
                                    <el-input v-model="cardInfo.virtualNo" style="width: 70%;" size="mini">
                                        <el-button slot="append"
                                            @click="updateSimVriNo(cardInfo.virtualNo); isEdit = false">修改虚拟号</el-button>
                                    </el-input>
                                </template>
                            </el-col>
                            <el-col :span="6">卡备注：
                                <el-input v-model="cardInfo.remark" size="mini" style="width:70%;">
                                    <el-button slot="append" @click="updateLimitNumber(cardInfo.iccid)">修改备注</el-button>
                                </el-input>
                            </el-col>



                        </el-row>
                    </el-col>
                </el-row>
            </div>


            <div class="section3">
                <h4>套餐详情</h4>
                <div>
                    <div v-for="(item, index) in visiblePackageList" :key="item.id" style="margin-bottom:40px;">
                        <h5><span class="span-defined">订单号：{{ item.id }}</span>套餐名称：{{ item.packageName }}</h5>
                        <el-row>
                            <el-col :span="5" class="progressOuter">
                                <el-progress :stroke-width="8" :percentage="item.usedFlowRate / item.flowRate * 100"
                                    :show-text="false"></el-progress>
                                <div v-if="item.state != 1">
                                    <div class="fr">剩余：{{ decrease(fluxMtoG(item.flowRate), fluxMtoG(item.usedFlowRate))
                                        }}G
                                    </div>
                                    <div>已用：{{ fluxMtoG(item.usedFlowRate) }}G / {{ fluxMtoG(item.flowRate) }}G</div>
                                </div>
                                <div v-else>
                                    <div class="fr">剩余：{{ decrease(item.flowRate, item.usedFlowRate) }}分钟</div>
                                    <div>已用：{{ item.usedFlowRate }}分钟 / {{ item.flowRate }}分钟</div>
                                </div>
                            </el-col>
                            <el-col :span="6" style="text-align: center;">
                                <p v-if="item.state == 4" class="progressOuter pOuter" style="color: red;">退款中</p>
                                <p v-else-if="item.state == 3" class="progressOuter pOuter" style="color: red;">已退款</p>
                                <p v-if="item.state == 1">
                                    已用（真）：{{ item.usedFlowRate }} 分钟
                                </p>
                                <p v-else>
                                    已用（真）：{{ fluxMtoG(item.realData) }}G
                                </p>
                            </el-col>
                            <el-col :span="4">流量百分比：{{ item.flowRatePercent }}%</el-col>

                            <el-col :span="5">
                                <p class="progressOuter pOuter">生效时间：{{ item.startTime }}</p>
                                <p v-if="isExpiredTime(item.endTime)" style="color: red;">过期时间：{{ item.endTime }}</p>
                                <p v-else>过期时间：{{ item.endTime }}</p>
                            </el-col>
                            <el-col :span="4">
                                <el-button @click="showChangePkgEndTimeHandler(item)" size="mini">修改过期时间</el-button>
                                <el-button @click="showChangePkgEndTimeHandler1(item)" size="mini">修改套餐流量</el-button>
                                <el-button type="danger" @click="deleteSimPkgById(item.id)"
                                    size="mini">删除此套餐</el-button>
                            </el-col>
                        </el-row>

                        <!-- 查看更多/折叠按钮：显示在最后一个可见套餐的中间列 -->
                        <div v-if="cardInfo.simPackageList.length > 4 && index === visiblePackageList.length - 1"
                            style="margin-top: 8px; text-align: center;">
                            <el-button size="small" :icon="isPackageFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                                @click="isPackageFold = !isPackageFold"
                                style="background-color: #2c5f9e; border-color: #2c5f9e; color: #fff;">
                                {{ isPackageFold ? '查看更多套餐（共' + cardInfo.simPackageList.length + '个）' : '收起套餐' }}
                            </el-button>
                        </div>
                    </div>

                    <div style="margin-top: -30px; font-size: 16px; font-weight: 600;  text-align: center;"  v-if="getSum > 0">
                        <el-row>
                            <el-col :span="7">&nbsp;</el-col>
                            <el-col :span="8" style="text-align: center;">本月已用流量：{{ cardInfo.monthTotal ?
                                fluxMtoG(cardInfo.monthTotal) : 0 }} G
                                ；&nbsp;总计已用流量：{{ getSum }} G</el-col>
                        </el-row>
                    </div>
                </div>
            </div>

            <div class="section3">
                <h4>代理商数据详情(2小时更新一次)</h4>
                <h5>
                    <span class="span-data ">
                        <div> 代理商名称：{{ cardInfo.agentMap.name }}</div>
                        <div> 卡板总数：{{ cardInfo.agentMap.totalSim }}</div>
                        <div> 已激活总数：{{ cardInfo.agentMap.actived }}</div>
                        <div> 在用总数：{{ cardInfo.agentMap.activing }}</div>
                        <div> 激活率：{{ cardInfo.agentMap.jihuo }}%</div>
                        <div> 续费率：{{ cardInfo.agentMap.zaiwang }}%</div>
                    </span>
                </h5>
            </div>
            <div class="section3">
                <h4>通道数据详情(2小时更新一次)</h4>
                <h5>
                    <span class="span-data">
                        <div> 通道名称：{{ cardInfo.supplierMap.name }}</div>
                        <div> 卡板总数：{{ cardInfo.supplierMap.totalSim }}</div>
                        <div> 已激活总数：{{ cardInfo.supplierMap.actived }}</div>
                        <div> 在用总数：{{ cardInfo.supplierMap.activing }}</div>
                        <div> 激活率：{{ cardInfo.supplierMap.jihuo }}% </div>
                        <div> 续费率：{{ cardInfo.supplierMap.zaiwang }}%</div>
                    </span>
                </h5>
            </div>


            <div class="section4">
                <h4>操作管理</h4>
                <div>
                    <el-button size="normal" @click="showAddPkg" icon="el-icon-edit">添加套餐</el-button>
                    <el-button size="normal" @click="selectShebei">设备管理</el-button>
                    <el-button size="normal" @click="updateShebei">修改设备卡号 </el-button>

                    <el-button size="normal" @click="stopSimHandler" plain icon="el-icon-s-ticket">停机</el-button>
                    <el-button size="normal" @click="resetSimHandler" plain icon="el-icon-s-ticket">复机</el-button>
                    <el-button size="normal" @click="openData" plain icon="el-icon-s-ticket">数据开启</el-button>
                    <el-button size="normal" @click="stopData" plain icon="el-icon-s-ticket">数据关闭</el-button>
                    <el-button size="normal" @click="cuccUpdateLog" plain icon="el-icon-s-ticket">运营商变更记录</el-button>
                    <el-button size="normal" @click="stateRecordListHandler" icon="el-icon-search">停复机记录</el-button>
                    <el-button size="normal" @click="noBIndSIm" icon="el-icon-s-ticket">机卡解绑</el-button>
                    <el-button size="normal" @click="leXuanFlg = true" icon="el-icon-s-ticket">河北广电解绑</el-button>
                    <el-button size="normal" @click="resetSimHandler1" plain
                        icon="el-icon-s-ticket">广电机卡复机（先解绑）</el-button>
                    <el-button size="normal" @click="backIccid" icon="el-icon-s-ticket">卡板回收</el-button>
                    <el-button size="normal" @click="showSimHandle" icon="el-icon-s-ticket">分销代理商</el-button>
                    <el-button size="normal" @click="showToNewCardHandler" icon="el-icon-s-ticket">老卡转新卡</el-button>
                    <el-button size="normal" @click="simDiagnosisHandler" icon="el-icon-s-ticket">刷新复机</el-button>
                    <el-button size="normal" @click="getFluxDetailListHandler" icon="el-icon-search">流量使用情况 </el-button>
                    <el-button size="normal" @click="showChangePkgGoupHandler" icon="el-icon-s-ticket">变更套餐组
                    </el-button>
                    <el-button size="normal" @click="showChangeCardStateHandler" icon="el-icon-s-ticket">变更卡状态
                    </el-button>
                    <el-button size="normal" @click="showAddRealNameSearch" icon="el-icon-search">实名查询 </el-button>
                    <el-button size="normal" @click="resetFlow" plain icon="el-icon-s-ticket">重置流量</el-button>
                    <el-button size="normal" @click="showToNewCard12" plain icon="el-icon-delete">清除卡数据</el-button>
                    <el-button size="normal" @click="showToNewCard13" plain icon="el-icon-delete">删除卡板</el-button>
                    <el-button size="normal" @click="resetPassword" plain icon="el-icon-s-ticket">重置余额密码</el-button>
                    <el-button size="normal" @click="showChangeBalanceDialog" icon="el-icon-s-ticket">修改用户余额</el-button>
                    <el-button type="normal" plain @click="singleLimitDialog = true">限速设置</el-button>
                    <el-button type="normal" plain @click="chgFlowSingleVisible = true"
                        icon="el-icon-edit">单卡虚量</el-button>
                    <el-button type="normal" plain @click="reloadSim" icon="el-icon-edit">移动/联通重置上网</el-button>

                    <el-button size="normal" @click="deleteAuth" plain icon="el-icon-delete">删除卡缓存</el-button>
                    <!-- <el-button size="normal" @click="addAuth" plain icon="el-icon-s-ticket">添加实名缓存</el-button> -->

                    <el-button size="normal" @click="bindDetail" icon="el-icon-s-ticket">用户绑定详情</el-button>

                    <el-button type="normal" plain @click="selectCmccStop">移动停机原因查询</el-button>
                    <el-button type="normal" plain @click="selectCmccOpend">移动设备开关机查询</el-button>
                    <el-button type="normal" plain @click="selectCmccLin">移动设备在线状态查询</el-button>
                     <el-button type="normal" plain @click="selectCmccLimit">移动区域限制查询</el-button>


                </div>
            </div>
            <div class="section5">
                <h4>往期订单</h4>
                <el-table :data="tableData" border :row-style="{ 'background-color': cardInfo.buildColor }">
                    <el-table-column prop="orderNo" width="240" label="订单号"></el-table-column>
                    <el-table-column prop="packageName" width="120" label="套餐名称"></el-table-column>
                    <el-table-column prop="packageTypeName" width="120" label="套餐类型"></el-table-column>
                    <el-table-column label="套餐流量" width="120">
                        <template slot-scope="scope">
                            <span>{{ fluxMtoG(scope.row.flowRate) }}G</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" width="160" label="订购时间"></el-table-column>
                    <el-table-column prop="createTypeName" width="120" label="订购类型"></el-table-column>
                    <el-table-column prop="isNextMonthName" width="120" label="生效时间"></el-table-column>
                    <el-table-column label="备注">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark" clearable
                                @blur="modifyOrderInfoHandler(scope.row)"></el-input>
                            <!-- <a href="javascript:void(0)" @click="showOrderDetailHandler(scope.row)">{{scope.row.remark}}</a>     -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>

            <div class="section5">
                <h4>余额订单</h4>
                <el-table :data="tableDataYu" border :row-style="{ 'background-color': cardInfo.buildColor }">
                    <el-table-column prop="orderNo" label="订单号"></el-table-column>
                    <el-table-column prop="priceRmb" label="充值金额"></el-table-column>
                    <el-table-column prop="payTypeName" label="支付方式"></el-table-column>
                    <el-table-column prop="payStateName" label="支付状态"></el-table-column>
                    <el-table-column prop="createTime" label="订购时间"></el-table-column>
                </el-table>
                <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination> -->
            </div>


        </template>

        <el-dialog :append-to-body="true" title="修改过期时间" :visible.sync="endTimeVisible" width="600px"
            @close="endTimecancel" :close-on-click-modal="false">
            <el-form ref="endTimeForm" :model="endTimeForm" label-width="120px">
                <el-form-item label="修改方式：" prop="type">
                    <el-select v-model="endTimeForm.type">
                        <el-option value="1" label="指定过期时间">指定过期时间</el-option>
                        <el-option value="2" label="指定延长天数"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="原过期时间：">
                    <div>{{ endTimeForm.oldTimeString }}</div>
                </el-form-item>
                <el-form-item v-if="endTimeForm.type == 1" label="新开始时间：" prop="newTimeString">
                    <el-date-picker v-model="endTimeForm.newEndString" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item v-if="endTimeForm.type == 1" label="新过期时间：" prop="newTimeString">
                    <el-date-picker v-model="endTimeForm.newTimeString" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item v-else label="延长天数：" prop="dayNum">
                    <el-input v-model="endTimeForm.dayNum" placeholder="请输入天数" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="endTimeForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgEndTimeHandler">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="修改流量信息" :visible.sync="endTimeVisible1" width="600px"
            @close="endTimecancel1" :close-on-click-modal="false">
            <el-form ref="endTimeForm" :model="endTimeForm" label-width="120px">

                <el-form-item label="已使用流量：" prop="use">
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="endTimeForm.use" clearable></el-input-number> GB
                    </el-col>
                </el-form-item>
                <el-form-item label="总流量：" prop="total">
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="endTimeForm.total" clearable></el-input-number>GB
                    </el-col>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel1">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgEndTimeHandler1">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="新增套餐" :visible.sync="addPkgVisible" width="600px" @close="addPkgCancel"
            :close-on-click-modal="false">
            <el-form ref="addPkgForm" :model="addPkgForm" :rules="addPkgRules" label-width="130px">
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-radio-group v-model="addPkgForm.packageId" class="pkgName" @change="changeAddPkgFormItem">
                        <el-radio v-for="item in pkgList" :key="item.id" :label="item.id" style="padding: 10px 0;">
                            {{ item.name }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth" v-if="addPkgFormIsNextMonth">
                    <el-select v-model="addPkgForm.isNextMonth">
                        <el-option value="0" label="本月生效">本月生效</el-option>
                        <el-option value="1" label="次月生效">次月生效</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="购买上游套餐：" prop="toBuy">
                    <el-radio-group v-model="addPkgForm.toBuy">
                        <el-radio :label="2">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="addPkgForm.remark" placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddPkgHandle">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="转新卡" :visible.sync="toNewCardVisible" width="600px"
            @close="toNewCardCancel" :close-on-click-modal="false">
            <el-form ref="toNewCardForm" :model="toNewCardForm" label-width="120px">
                <el-form-item label="新卡ICCID/虚拟号：" prop="iccid">
                    <el-input v-model.trim="toNewCardForm.iccid" clearable></el-input>
                </el-form-item>
                <el-form-item label="类型：" prop="moveType">
                    <el-radio-group v-model="toNewCardForm.moveType">
                        <el-radio label="1">全部</el-radio>
                        <el-radio label="2">仅转流量</el-radio>
                        <el-radio label="3">仅转层级</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model.trim="toNewCardForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="toNewCardCancel">取 消</el-button>
                <el-button type="primary" @click="sureToNewCardHandler">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="停复机记录" :visible.sync="stateRecordVisible" width="80%"
            :close-on-click-modal="false">
            <el-table :data="tableData_record" border height="421">
                <el-table-column prop="stateName" label="操作类型"></el-table-column>
                <el-table-column prop="createTypeName" label="操作来源"></el-table-column>
                <el-table-column prop="createTime" label="操作时间"></el-table-column>
                <el-table-column prop="createOptName" label="操作人"></el-table-column>
                <el-table-column prop="failReason" label="失败原因"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChangeRecord" @current-change="handleCurrentChangeRecord"
                :current-page="currentPage_record" :page-sizes="[10, 50, 100, 500]" :page-size="pageSize_record"
                layout="total, sizes, prev, pager, next, jumper" :total="total_record">
            </el-pagination>
        </el-dialog>
        <el-dialog :append-to-body="true" title="流量使用详情" :visible.sync="fluxVisible" width="80%"
            :close-on-click-modal="false">
            <el-table :data="tableData_flux" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column label="本月已用流量（G）">
                    <template slot-scope="scope">
                        <span>{{ fluxMtoG(scope.row.monthTotal) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="查询时间 "></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChangeFlux" @current-change="handleCurrentChangeFlux"
                :current-page="currentPage_flux" :page-sizes="[10, 50, 100, 500]" :page-size="pageSize_flux"
                layout="total, sizes, prev, pager, next, jumper" :total="total_flux">
            </el-pagination>
        </el-dialog>
        <el-dialog :append-to-body="true" title="变更套餐组" :visible.sync="changePkgGroupVisible" width="600px"
            @close="changePkgGroupCancel" :close-on-click-modal="false">
            <el-form ref="pkgGroupForm" :model="pkgGroupForm" label-width="120px">
                <el-form-item label="原套餐组名称：">
                    <span>{{ cardInfo.basePkgGroupName }}</span>
                </el-form-item>
                <el-form-item label="新套餐组名称：" prop="newPkgGroup">
                    <el-select v-model="pkgGroupForm.newPkgGroup" filterable>
                        <el-option v-for="item in allowPkgGroup" :key="item.id" :value="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="pkgGroupForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changePkgGroupCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgGroupHandler">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="变更卡状态" :visible.sync="changeStateVisible" width="600px"
            @close="changeStateCancel" :close-on-click-modal="false">
            <el-form ref="changeStateForm" :model="changeStateForm" :rules="changeStateRules" label-width="100px">

                <el-form-item label="类型：" prop="state">
                    <el-select v-model="changeStateForm.state" clearable>
                        <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description"
                            :label="'转' + item.description"></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="changeStateForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeStateCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangeStateHandler">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 订单详情 -->
        <el-dialog :append-to-body="true" title="订单详情" :visible.sync="orderDetailVisible" width="600px"
            :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订单号：</label>
                <span>{{ orderDetailForm.orderNo }}</span>
            </div>

            <div class="lineInDialog">
                <label>套餐名称：</label>
                <span>{{ orderDetailForm.packageName }}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{ orderDetailForm.priceRmb }} 元</span>
            </div>

            <div class="lineInDialog">
                <label>下单时间：</label>
                <span>{{ orderDetailForm.createTime }}</span>
            </div>

            <div class="lineInDialog">
                <label>备注：</label>
                <div v-html="orderDetailForm.remark">
                </div>

            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="orderDetailVisible = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :append-to-body="true" title="添加叠加包" :visible.sync="overlayPkgVisible" width="600px"
            @close="overlayPkgCancel" :close-on-click-modal="false">
            <el-form ref="overlayPkgForm" :model="overlayPkgForm" :rules="overlayPkgRules" label-width="100px">
                <el-form-item label="套餐组：" prop="typeGroupId">
                    <el-select v-model="overlayPkgForm.typeGroupId" @change="changeHandler" filterable>
                        <el-option v-for="item in overlayPkgGroup" :key="item.id" :value="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-select v-model="overlayPkgForm.packageId" clearable>
                        <el-option v-for="item in overlayPkgList" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="overlayPkgForm.isNextMonth" clearable>
                        <el-option value=0 label="本月生效"></el-option>
                        <el-option value=1 label="次月生效"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="overlayPkgForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="overlayPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddOverlayPkg">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="修改余额" :visible.sync="chgBalanceVisible" width="600px"
            @close="hideChangeBalanceDialog()" :close-on-click-modal="false">
            <el-form ref="changeBalanceForm" :model="changeBalanceForm" label-width="120px">
                <el-form-item label="iccid：">
                    <label>{{ changeBalanceForm.iccid }}</label>
                </el-form-item>
                <el-form-item label="变动类型:">
                    <el-radio v-model="changeBalanceForm.type" label="1">增加</el-radio>
                    <el-radio v-model="changeBalanceForm.type" label="2">扣减</el-radio>
                </el-form-item>

                <el-form-item label="金额：" prop="amountRmb">
                    <el-input-number v-model="changeBalanceForm.amountRmb" :precision="2" :step="1" :min="0">
                    </el-input-number>
                </el-form-item>

                <el-form-item label="关联单号：" prop="orderNo">
                    <el-input v-model="changeBalanceForm.orderNo" placeholder="请输入关联单号" maxlength="24" show-word-limit
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="changeBalanceForm.remark" placeholder="请输入内容" rows="3"
                        maxlength="50" show-word-limit clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="hideChangeBalanceDialog()">取 消</el-button>
                <el-button type="primary" @click="doChangeBalance()">确 定</el-button>
            </div>
        </el-dialog>




        <el-dialog :append-to-body="true" title="解除限速" :visible.sync="limitFlg" width="600px"
            @close="hideChangeBalanceDialog()" :close-on-click-modal="false">
            <el-form ref="limitData" :model="limitData" label-width="120px">

                <el-form-item label="限速ID：" prop="limitSpeed">
                    <el-input type="textarea" v-model="limitData.limitSpeed" placeholder="联通卡请输入限速ID，其它卡选填"
                        show-word-limit clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="hideChangeBalanceDialog()">取 消</el-button>
                <el-button type="primary" @click="noLimitSim()">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :append-to-body="true" title="卡片分销" :visible.sync="simHandleVisibale" width="600px"
            @close="cancelSold" :close-on-click-modal="false">
            <el-form ref="simHandleForm" :model="simHandleForm" label-width="120px">
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="simHandleForm.agentId" filterable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelSold">取 消</el-button>
                <el-button type="primary" @click="simDistributHandler">确 定</el-button>
            </div>
        </el-dialog>






        <el-dialog :append-to-body="true" title="限速设置" :visible.sync="singleLimitDialog" width="600px"
            :close-on-click-modal="false">
            <el-form ref="limitForm" :model="singleLimitForm" label-width="100px">

                <el-form-item label="限速类别：" prop="limitSpeed">
                    <el-select v-model="singleLimitForm.limitSpeed" clearable>
                        <el-option v-for="item in limitList" :key="item.code" :value="item.code"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="限速备注" prop="myRemark">
                    <el-input v-model="singleLimitForm.myRemark" placeholder="限速备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelsSngleLimit()">取 消</el-button>
                <el-button type="primary" @click="singleLimitSpeed()">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :append-to-body="true" title="单卡修改" :visible.sync="chgFlowSingleVisible" width="600px"
            @close="cancelChgFlowSingle()" :close-on-click-modal="false">
            <el-form ref="chgFlowFormSingle" :model="chgFlowFormSingle" label-width="120px">

                <el-form-item label="可用流量比：" prop="flowRatePercent">
                    <el-input-number v-model.trim="chgFlowFormSingle.flowRatePercent" :min="0"
                        :max="100"></el-input-number>
                    <label class='label-defined percent-label'>%</label>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="chgFlowFormSingle.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelChgFlowSingle()">取 消</el-button>
                <el-button type="primary" @click="sureChgFlowSingleHandler()">确 定</el-button>
            </div>
        </el-dialog>






        <el-dialog :append-to-body="true" title="绑定详情" :visible.sync="bindInflg" width="800px" @close="bindCancel()"
            :close-on-click-modal="false">
            <el-form ref="cardInfo" :model="cardInfo" label-width="120px">

                <el-row style="margin-bottom: 12px;">
                    <el-col :span="8">姓名： {{ cardInfo.userName }}</el-col>
                    <el-col :span="8">手机号： {{ cardInfo.userPhone }}</el-col>
                    <el-col :span="8">身份证： {{ cardInfo.idcard }}</el-col>
                </el-row>
                <el-image style="width:400px; height: 180px" :src="cardInfo.idcardImg"
                    :preview-src-list="[cardInfo.idcardImg]">
                </el-image>
                <!--   图片地址  cardInfo.idcardImg   图片可点击放大    -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bindCancel()">取 消</el-button>
                <!-- <el-button type="primary" @click="noLimitSim()">确 定</el-button> -->
            </div>
        </el-dialog>


        <el-dialog :append-to-body="true" title="标记颜色设置" :visible.sync="colorShow" width="400px"
            :close-on-click-modal="false">
            <el-form ref="limitForm" :model="cardInfo" label-width="100px">

                <el-form-item label="颜色：" prop="buildColor">
                    <el-select v-model="cardInfo.buildColor" clearable>
                        <el-option v-for="item in colorList" :key="item.value" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="colorShow = false">取 消</el-button>
                <el-button type="primary" @click="toBuildSim(1)">确 定</el-button>
            </div>
        </el-dialog>






        <el-dialog :append-to-body="true" title="设备详情信息" :visible.sync="shebeiFlg" width="800px" @close="shebeicancel"
            :close-on-click-modal="false" class="device-detail-dialog" custom-class="device-dialog-height">
            <div class="detail-wrapper">
                <!-- 基本信息（新增可编辑的卡槽、WIFI账号密码） -->
                <div class="detail-card">
                    <p class="card-title"><i class="el-icon-info"></i> 基础信息</p>
                    <el-row :gutter="20">
                        <!-- 新增：在用卡槽（可切换） -->
                        <el-col :span="8">
                            <div class="field">
                                <label>在用卡槽</label>
                                <el-select v-model="shebeiInfo.curSimCato" clearable style="width: 120px;">
                                    <el-option :value=0 label="移动卡"></el-option>
                                    <el-option :value=1 label="电信卡"></el-option>
                                    <el-option :value=2 label="联通卡"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <!-- 新增：WIFI账号（可编辑） -->
                        <el-col :span="8">
                            <div class="field">
                                <label>WIFI账号</label>
                                <el-input v-model="shebeiInfo.wifiName" clearable style="width: 180px;"></el-input>
                            </div>
                        </el-col>
                        <!-- 新增：WIFI密码（可编辑） -->
                        <el-col :span="8">
                            <div class="field">
                                <label>WIFI密码</label>
                                <el-input v-model="shebeiInfo.wifiPass" clearable style="width: 180px;"></el-input>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>设备电量</label><span>{{ shebeiInfo.battery || 0 }} %</span></div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>设备在线状态</label><span>{{ shebeiInfo.onLine || '-' }}</span></div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>WIFI链接数</label><span>{{ shebeiInfo.clientNumber || 0 }}</span>
                            </div>
                        </el-col>
                         <el-col :span="8">
                            <div class="field"><label>信号强度</label><span>{{ shebeiInfo.rssi || 0 }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 流量卡信息 -->
                <div class="detail-card">
                    <p class="card-title"><i class="el-icon-phone"></i> 流量卡信息</p>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="field"><label>移动卡卡号</label><span>{{ shebeiInfo.outIccid || '-' }}</span></div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>移动实名状态</label><span>{{ shebeiInfo.outAuthName || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>移动当月用量</label><span>{{ shebeiInfo.outIccidUse || '-' }} /GB</span>
                            </div>
                        </el-col>

                        <el-col :span="8">
                            <div class="field"><label>电信卡卡号</label><span>{{ shebeiInfo.inIccid1 || '-' }}</span></div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>电信实名状态</label><span>{{ shebeiInfo.in1AuthName || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>电信当月用量</label><span>{{ shebeiInfo.inIccid1Use || '-' }} /GB</span>
                            </div>
                        </el-col>

                        <el-col :span="8">
                            <div class="field"><label>联通卡卡号</label><span>{{ shebeiInfo.inIccid2 || '-' }}</span></div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>联通实名状态</label><span>{{ shebeiInfo.in2AuthName || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>联通当月用量</label><span>{{ shebeiInfo.inIccid2Use || '-' }} /GB</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 切换配置 -->
                <div class="detail-card">
                    <p class="card-title"><i class="el-icon-setting"></i> 自动切换配置信息</p>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="field"><label>每日切换</label><span>{{ shebeiInfo.dayQie || '-' }}</span></div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>每日切换（区域限制查询）</label><span>{{ shebeiInfo.dayQieLimit || '-'
                                    }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="field"><label>月初切换</label><span>{{ shebeiInfo.monthQie || '-' }}</span></div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <!-- 新增：保存修改按钮 -->
                <el-button @click="shebeicancel">关 闭</el-button>
                <el-button type="primary" @click="shebeiSure(0)">保存修改</el-button>
                <el-button type="primary" @click="shebeiSure(1)">保存修改(调用接口)</el-button>
            </div>
        </el-dialog>


        <el-dialog :append-to-body="true" title="修改设备" :visible.sync="updateShebeiFlg" width="600px"
            @close="shebeicancel" :close-on-click-modal="false">
            <el-form ref="updateShebeiData" :model="updateShebeiData" label-width="100px">

                <el-form-item label="设备号：" prop="virtualNo">
                    <el-input v-model="updateShebeiData.virtualNo" disabled clearable></el-input>
                </el-form-item>

                <el-form-item label="IMEI：" prop="imei">
                    <el-input v-model="updateShebeiData.imei" clearable></el-input>
                </el-form-item>

                <el-form-item label="移动卡：" prop="outIccid">
                    <el-input v-model="updateShebeiData.outIccid" clearable></el-input>
                </el-form-item>
                <el-form-item label="电信卡：" prop="inIccid1">
                    <el-input v-model="updateShebeiData.inIccid1" clearable></el-input>
                </el-form-item>
                <el-form-item label="联通卡：" prop="inIccid2">
                    <el-input v-model="updateShebeiData.inIccid2" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="shebeicancel">取 消</el-button>
                <el-button type="primary" @click="sureUpdateShebei">确定修改</el-button>

            </div>
        </el-dialog>


        <el-dialog :append-to-body="true" title="IEI" :visible.sync="leXuanFlg" width="600px"
            :close-on-click-modal="false">
            <el-form ref="lexuanData" :model="lexuanData" label-width="100px">

                <el-form-item label="旧IEMI" prop="oldImei">
                    <el-input v-model="lexuanData.oldImei" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="新IEMI" prop="new">
                    <el-input v-model="lexuanData.newImei" placeholder=""></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="leXuanFlg = false">取 消</el-button>
                <el-button type="primary" @click="updateLeXun()">确 定</el-button>
            </div>
        </el-dialog>



        <el-dialog :append-to-body="true" title="变更记录" :visible.sync="cuccFlg" width="80%"
            :close-on-click-modal="false">
            <el-table :data="cuccData" border height="500">
                <el-table-column prop="field" label="字段"></el-table-column>
                <el-table-column prop="priorValue" label="变更前状态"></el-table-column>
                <el-table-column prop="value" label="变更后状态"></el-table-column>
                <el-table-column prop="effectiveDate" label="生效日期"></el-table-column>
                <el-table-column prop="userName" label="用户名"></el-table-column>
                <el-table-column prop="state" label="状态"></el-table-column>
            </el-table>
        </el-dialog>


    </div>
</template>

<script>
import {
    getSimDetailInfo, getOneSIMOrderList, addPkg, getPkgList, getAllowChangePkgGroup, toChangePkgGroup, changePkgEndTime, delayPkgEndTime, delayPkgEndTime1, toNewCard,
    simDiagnosis, updateState, stopSim, resetSim, getFluxDetailList, getSimStopStartRecordList, changeCardState, getOverlayPkgOptions, simDistribut, getRealName, getOneSIMOrderListYu,
    simRecovery
} from '@/api/sim.js'
import { modifyOrderRemark } from '@/api/order.js'
import { sureChgFlowRateSingle } from '@/api/sim.js'
import { getUserBalance, resetPwd, changeBalance } from '@/api/record.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
import '@/styles/txt.wav.css'

export default {
    data() {
        return {
            // 新增：控制套餐折叠状态，默认折叠（只显示前4个）
            isPackageFold: true,
            //中国移动
            limitList: [
                { label: '速率恢复', code: '0' },
                { label: 'APN-AMBR=1Mbps', code: '1' },
                { label: 'APN-AMBR=3Mbps', code: '2' },
                { label: 'APN-AMBR=5Mbps', code: '3' },
            ],

            colorList: [
                { value: '#FFFFFF', label: '白色' },
                { value: '#FFEEE6', label: '淡橙色' },
                { value: '#FF8040', label: '橙色' },
                { value: '#FFC0CB', label: '粉色' },
                { value: '#FF00FF', label: '紫色' },
                { value: '#5C3317', label: '棕色' },
                { value: '#0000FF', label: '蓝色' },
            ],
            colorShow: false,
            chgFlowFormSingle: {
                iccid: '',
                flowRatePercent: 0,
                remark: ''
            },
            chgFlowSingleVisible: false,
            isEdit: false,
            singleLimitForm: {
                iccid: null,
                limitSpeed: null,
                myRemark: '',
                isDown: ''
            },
            singleLimitDialog: false,
            limitData: {
                limitSpeed: ''
            },
            cardDetailsForm: {
                iccid: ''
            },
            simHandleForm: {
                agentId: ''
            },
            tableDataYu: [],

            showDetail: false,
            cardInfo: {
                limitUse: '',
                vipName: '',
                vipTime: '',
                dataState: '',
                supplierCode: '',
                noUseName: '',
                userCity: '',
                sumOutData: '',
                id: '',
                remark: '',
                xuName: '',
                userName: '',
                userPhone: '',
                idcardImg: '',
                idcard: '',
                isDown: '',
                virtualNo: '',
                limitStateName: '',
                simAmount: '',
                supplierTypeCode: '',
                iccid: '',
                supplierName: '',
                agentPathNames: '',
                alias: '',
                cardTypeName: '',
                endTime: '',
                intoNo: '',
                cardState: '',
                flowRatePool: '',
                basePkgGroupName: '',
                cardStateName: '',
                flowRatePercent: null,
                simPackageList: [],
                monthTotal: null,
                changeStateRemark: "",
                userPhoneCount: '',
                idCardCount: '',
                idCardBuildCount: '',
                idcard: '',
                supplierRemark: '',
                agentRemark: '',
                supplierMap: {
                    name: '', //通道名称
                    totalSim: '', //总卡数
                    actived: '',
                    activing: '',
                    jihuo: '',
                    zaiwang: '',
                },
                agentMap: {
                    name: '', // 代理商名称
                    totalSim: '',  //总卡数
                    actived: '',
                    activing: '',
                    jihuo: '',
                    zaiwang: '',
                },
                isBuild: '', // 0 未标记  1 已标记
                buildColor: '', //标记颜色
                stopOut: '',
                dataOut: ''
            },
            tableData: [],
            currentPage: 1,
            pageSize: 15,
            total: 0,
            addPkgVisible: false,       //添加套餐
            pkgList: [],
            addPkgForm: {
                isNextMonth: '0',
                packageId: '',
                toBuy: 1,
                remark: ''
            },
            addPkgFormIsNextMonth: false,
            toNewCardVisible: false,    //转新卡
            toNewCardForm: {
                iccid: '',
                moveType: '1',
                remark: ''
            },
            stateRecordVisible: false,  //停复机记录
            'tableData_record': [],
            'currentPage_record': 1,
            'pageSize_record': 10,
            'total_record': 0,
            fluxVisible: false,         //流量使用详情
            'tableData_flux': [],
            'currentPage_flux': 1,
            'pageSize_flux': 10,
            'total_flux': 0,
            endTimeVisible1: false, //修改流量信息
            endTimeVisible: false,     //修改过期时间
            endTimeForm: {
                type: '1',
                pkgId: '',
                oldTimeString: '',
                newTimeString: '',
                dayNum: 0,
                remark: '',
                total: '',
                use: '',
                newEndString: ''
            },
            changePkgGroupVisible: false, //变更套餐组
            allowPkgGroup: [],
            pkgGroupForm: {
                newPkgGroup: '',
                remark: ''
            },
            changeStateVisible: false,    //变更卡状态
            cardStateOption: [],
            changeStateForm: {
                state: '',
                remark: ''
            },
            overlayPkgVisible: false,
            overlayPkgForm: {
                typeGroupId: '',
                packageId: '',
                isNextMonth: '',
                remark: ''
            },
            overlayPkgGroup: [],
            overlayPkgList: [],
            cardDetailsRules: {
                iccid: [{ required: true, message: '请输入ICCID号或接入号', trigger: 'blur' }]
            },
            addPkgRules: {
                packageId: [{ required: true, message: '请选择要充值的套餐', trigger: 'blur' }],
                toBuy: [{ required: true, message: '请选择', trigger: 'change' }]
            },
            toNewCardRules: {
                iccid: [{ required: true, validator: this.checkIccid, trigger: 'change' }]
            },
            changeStateRules: {
                state: [{ required: true, message: '请选择变更状态', trigger: 'blur' }],
                remark: [{ required: true, message: '请选择输入变更原因', trigger: 'blur' }],
            },
            overlayPkgRules: {

            },
            agentListOption: [],
            simHandleVisibale: false,
            orderDetailVisible: false,
            orderDetailForm: {},
            chgBalanceVisible: false,
            changeBalanceForm: {
                iccid: "",
                mobile: "",
                amountRmb: "",
                type: '1',
                orderNo: '',
                remark: '',
            },
            limitFlg: false,

            bindInflg: false,



            shebeiFlg: false,
            shebeiInfo: {
                iccid: '',
                moName: '', //在用卡槽
                useIccid: '',//在用卡号
                curSimCato: '',
                wifiName: '', //WIFI账号
                wifiPass: '',//WIFI密码
                onQie: 0,
                isShow: '',
                battery: '',//WIFI电量百分比 如80
                clientNumber: '', //WIFI链接数
                dayQie: '', //每日切换 如电信/移动
                dayQieLimit: '',//每日切换（区域限制） 如电信/移动
                monthQie: '', //月初切换 如电信/移动
                outIccid: '', //移动卡卡号
                inIccid1: '', //电信卡号
                inIccid2: '', //联通卡卡号
                outAuthName: '',//移动卡实名状态
                in1AuthName: '',//电信卡实名状态
                in2AuthName: '', //联通卡实名状态
                outIccidUse: '', //移动卡本月用量
                inIccid1Use: '', //电信卡本月用量
                inIccid2Use: '',//联通卡本月用量
                onLine: '',//设备在线状态 在线 /里面
                rssi:'',
            },
            updateShebeiFlg: false,
            updateShebeiData: {
                outIccid: '',
                inIccid1: '',
                inIccid2: '',
                virtualNo: '',
                imei: ''
            },

            leXuanFlg: false,
            lexuanData: {
                iccid: '',
                oldImei: '',
                newImei: '',
                supplierCode: ''
            },
            cuccFlg: false,
            cuccData: [],

        }
    },
    // 指令
    directives: {
        focus: {
            inserted: function (el) {
                function getFocus(element) {
                    if (element.nodeName === 'INPUT') {
                        element.focus();
                        return;
                    } else if (element.children.length > 0) {
                        for (let i = 0; i < element.children.length; i++) {
                            getFocus(element.children[i])
                            return;
                        }
                    }
                }
                getFocus(el);
            }
        }
    },
    methods: {
        cuccUpdateLog() {
            common.sysRequest("sim/cucc/log", { iccid: this.cardInfo.iccid, supplierId: this.cardInfo.supplierCode }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.cuccData = res.data.data;
                    this.cuccFlg = true;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },


        stopData() {
            common.sysRequest("sim/stop/data", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        openData() {
            common.sysRequest("sim/start/data", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        selectCmccStop() {
            common.sysRequest("sim/select/cmcc/stop", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        selectCmccOpend() {
            common.sysRequest("sim/select/cmcc/opend", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('开机');
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        selectCmccLin() {
            common.sysRequest("sim/select/cmcc/line", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('在线');
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

         selectCmccLimit() {
            common.sysRequest("sim/select/cmcc/limit", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                   this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        updateLeXun() {
            this.lexuanData.iccid = this.cardInfo.iccid;
            this.lexuanData.supplierCode = this.cardInfo.supplierCode;
            common.sysRequest("sim/update/other/ctcc", this.lexuanData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.leXuanFlg = false;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        shebeiReload() {
            this.$confirm('确定要恢复出厂设备吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest("sim/shebei/reload", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message)
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(err => console.error(err));

            }).catch(() => {

            });


        },
        retsartShebi() {
            this.$confirm('确定要重启设备吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest("sim/shebei/restart", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message)
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(err => console.error(err));

            }).catch(() => {

            });
        },

        sureUpdateShebei() {
            common.sysRequest("sim/update/shebei/info", this.updateShebeiData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                    this.updateShebeiFlg = false;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        updateShebei() {
            common.sysRequest("sim/select/shebei/info", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.updateShebeiData.virtualNo = res.data.data.vriNo;
                    this.updateShebeiData.outIccid = res.data.data.outIccid;
                    this.updateShebeiData.inIccid1 = res.data.data.inIccid1;
                    this.updateShebeiData.inIccid2 = res.data.data.inIccid2;
                    this.updateShebeiData.imei = res.data.data.imei;
                    this.updateShebeiFlg = true;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        selectShebei() {
            common.sysRequest("sim/select/shebei", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.shebeiInfo = res.data.data;
                    this.shebeiInfo.iccid = this.cardInfo.iccid;
                    this.shebeiFlg = true;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        shebeicancel() {
            this.shebeiFlg = false;
            this.updateShebeiFlg = false;
        },

        shebeiSure(onQie) {
            this.shebeiInfo.onQie=onQie;
            common.sysRequest("sim/update/shebei", this.shebeiInfo, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    this.shebeiFlg = false;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },



        backIccid() {
            var iccidStart = this.cardInfo.iccid;
            var iccidEnd = this.cardInfo.iccid;
            this.$confirm('确定要回收此卡板吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var data = {
                    iccidStart,
                    iccidEnd
                }
                simRecovery(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            }).catch(() => {

            });

        },
        deleteSimPkgById(id) {
            this.$confirm('确定要删除此套餐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest("sim/delete/pkg/id", { id: id }, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(err => console.error(err));
            }).catch(() => {

            });
        },


        toBuildSim(state) {
            var data = {
                idcard: this.cardInfo.idcard,
                iccid: this.cardInfo.iccid,
                buildColor: this.cardInfo.buildColor, // 当state=1 进行标记时， 需要用户选择要标记的颜色
                state: state
            }
            common.sysRequest("sim/to/build", data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.colorShow = false
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        bindDetail() {
            this.bindInflg = true;
        },
        bindCancel() {
            this.bindInflg = false;
        },

        deleteAuth() {
            common.sysRequest("sim/delete/auth", this.cardInfo, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        addAuth() {
            common.sysRequest("sim/add/auth", this.cardInfo, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        updateSimVriNo() {
            common.sysRequest("sim/update/vrino", this.cardInfo, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        //确定单卡修改
        sureChgFlowSingleHandler() {
            this.chgFlowFormSingle.iccid = this.cardInfo.iccid;
            this.$refs.chgFlowFormSingle.validate(valid => {
                if (valid) {

                    this.$confirm('确定要修改卡片流量比吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let params = this.chgFlowFormSingle;
                        let formData = new FormData();
                        Object.keys(params).forEach((key) => {
                            formData.append(key, params[key]);
                        });
                        sureChgFlowRateSingle(formData).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.cancelChgFlowSingle();//关闭弹窗
                                this.getSimDetailInfoHandler(this.cardInfo.iccid);//刷新页面
                            } else {
                                this.$message.error(res.data.message)
                            }
                        });
                    }).catch(() => {

                    });
                }
            })
        },

        cancelChgFlowSingle() {
            this.chgFlowSingleVisible = false;
        },

        reloadSim() {
            common.sysRequest("sim/to/reload", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        singleLimitSpeed() {
            this.singleLimitForm.iccid = this.cardInfo.iccid;
            this.singleLimitForm.isDown = this.cardInfo.isDown;
            let data = new FormData();
            Object.keys(this.singleLimitForm).forEach((key) => {
                data.append(key, this.singleLimitForm[key]);
            });

            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    common.sysRequest("sim/price/limit/speed/type", data, 'post').then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.cancelsSngleLimit();
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(err => console.error(err));
                }
            });

        },
        cancelsSngleLimit() {
            this.singleLimitForm.limitSpeed = null;
            this.singleLimitForm.iccid = null;
            this.singleLimitDialog = false;
        },



        simDistributHandler() {
            this.$refs.simHandleForm.validate(valid => {
                if (valid) {
                    var data = {
                        iccidStart: this.cardInfo.iccid,
                        iccidEnd: this.cardInfo.iccid,
                        agentId: this.simHandleForm.agentId
                    }
                    simDistribut(data).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success('分销完成');
                            this.simHandleVisibale = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },

        cancelSold() {
            this.simHandleVisibale = false;
        },
        showSimHandle() {
            if (!this.cardInfo.iccid) {
                this.$message.error('请输入要分销的ICCID');
                return false;
            } else {
                this.simHandleVisibale = true;
                common.getAgentListOptionCom(this, 'agentListOption');
            }
        },

        resetSimHandler1() {
            var data = {
                iccid: this.cardInfo.iccid
            }
            common.sysRequest('sim/activity/noBind', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                } else {
                    this.$message.error(res.data.message);
                }
            })

        },


        //复制
        copyOrderId() {
            var clipboard = new Clipboard('.copy_url')
            clipboard.on('success', e => {
                this.$message.success('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        updateLimitNumber(iccid) {
            var data = {
                iccid: this.cardInfo.iccid,
                remark: this.cardInfo.remark
            }
            common.sysRequest("sim/update/remark", data, 'post').then(res => {
                if (res.data.code == 200) {
                    //this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        noLimitSimFlg() {
            this.limitFlg = true;
        },
        noLimitSim() {
            var data = {
                iccid: this.cardInfo.iccid,
                limitSpeed: this.limitData.limitSpeed
            }
            common.sysRequest('sim/delete/limit/speed', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.limitFlg = false;
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        doChangeBalance() {
            this.$refs.changeBalanceForm.validate(valid => {
                if (valid) {
                    this.$confirm('确定要修改余额吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        changeBalance(this.changeBalanceForm).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success('余额修改成功');
                                this.getSimDetailInfoHandler(this.cardInfo.iccid);
                                this.hideChangeBalanceDialog();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        })
                    }).catch(() => {

                    });
                }
            });
        },
        hideChangeBalanceDialog() {
            this.limitFlg = false;
            this.chgBalanceVisible = false;
        },
        showChangeBalanceDialog() {
            this.changeBalanceForm.iccid = this.cardInfo.iccid;
            this.changeBalanceForm.mobile = '';
            this.chgBalanceVisible = true;
        },

        resetPassword() {
            this.$confirm('确定要重置密码吗？ 重置后密码为000000', '提示', {
                confirmButtonText: '确定重置',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                resetPwd({
                    iccid: this.cardInfo.iccid,
                    mobile: '1',
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {

            });

        },
        showToNewCard12() {
            this.$confirm("此操作会把卡的余额，套餐，订单，绑定手机记录全部删除 此操作不可逆且没有任何记录！。确定要操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                common.sysRequest('pkg/delete/pkg/iccid', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            })
        },

        showToNewCard13() {
            this.$confirm("此操作会把卡从系统中删除！ 此操作不可逆且没有任何记录！。确定要删除操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                common.sysRequest('sim/delete/simInfo', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            })
        },
        noBIndSIm() {
            var data = {
                iccid: this.cardInfo.iccid
            };
            common.sysRequest("external/ctcc/no/bind", { iccid: this.cardInfo.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('解绑成功！');
                } else {
                    this.$message.error(res.data.message);
                }

            })

        },
        addPkgCancel() {
            this.addPkgVisible = false;
            this.$refs.addPkgForm.resetFields();
        },
        endTimecancel() {
            this.endTimeVisible = false;
            this.$refs.endTimeForm.resetFields();
        },
        endTimecancel1() {
            this.endTimeVisible1 = false;
            this.$refs.endTimeForm.resetFields();
        },
        toNewCardCancel() {
            this.toNewCardVisible = false;
            this.$refs.toNewCardForm.resetFields();
        },
        changePkgGroupCancel() {
            this.changePkgGroupVisible = false;
            this.$refs.pkgGroupForm.resetFields();
        },
        changeStateCancel() {
            this.changeStateVisible = false;
            this.$refs.changeStateForm.resetFields();
        },
        overlayPkgCancel() {
            this.overlayPkgVisible = false;
            this.$refs.overlayPkgForm.resetFields();
        },
        getSimDetailInfoHandler(iccid, $event) {
            if ($event) {
                Object.assign(this.$data, this.$options.data());  //重置为初始值
                this.cardDetailsForm.iccid = iccid
            }
            this.$refs.cardDetailsForm.validate(valid => {
                if (valid) {
                    var data = {
                        iccid
                    }
                    getSimDetailInfo(data).then(res => {
                        if (res.data.code == 200) {
                            this.showDetail = true;
                            var result = res.data;
                            for (var key in this.cardInfo) {
                                this.cardInfo[key] = res.data.data[key];
                            }
                            this.$nextTick(() => {
                                this.updateStateHandler(iccid, false);
                                this.showDetail = true;
                            })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    this.getOneSIMOrderListHandler();
                }
            })
        },
        getOneSIMOrderListHandler() {
            var data = {
                perPageNum: this.pageSize,
                pageNo: this.currentPage,
                iccid: this.cardDetailsForm.iccid
            }
            getOneSIMOrderList(data).then(res => {  //获取往期来往订单
                if (res.data.code == 200) {
                    var result = res.data.data;
                    this.tableData = result.resultList;
                    this.total = result.totalNum;
                    this.currentPage = result.pageNo;
                    this.pageSize = result.perPageNum;
                } else {
                    this.$message.error(res.data.message);
                }
            })
            getOneSIMOrderListYu(data).then(res => {  //获取往期来往订单
                if (res.data.code == 200) {
                    var result = res.data.data;
                    this.tableDataYu = result.resultList;
                } else {
                    this.$message.error(res.data.message);
                }
            })

        },

        changeAddPkgFormItem(value) {
            for (let i = 0; i < this.pkgList.length; i++) {
                if (value == this.pkgList[i].id) {
                    this.addPkgFormIsNextMonth = this.pkgList[i].type == 2 || this.pkgList[i].type == 10 || this.pkgList[i].type == 14 || this.pkgList[i].type == 6 || this.pkgList[i].type == 17
                        || this.pkgList[i].type == 25;
                }
            }
        },
        updateStateHandler(iccid, showSuccessMsg) {
            var data = { iccid };
            updateState(data).then(res => {
                if (res.data.code == 200) {
                    if (showSuccessMsg) {
                        this.$message.success(res.data.message);
                    }
                    getSimDetailInfo(data).then(res => {
                        if (res.data.code == 200) {
                            this.showDetail = true;
                            var result = res.data;
                            for (var key in this.cardInfo) {
                                this.cardInfo[key] = res.data.data[key];
                            }
                        }
                    });
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showChangePkgEndTimeHandler(item) {
            this.endTimeVisible = true;
            this.endTimeForm.oldTimeString = item.endTime;
            this.endTimeForm.pkgId = item.id;
        },
        showChangePkgEndTimeHandler1(item) {
            this.endTimeVisible1 = true;
            this.endTimeForm.total = item.flowRate / 1024;
            this.endTimeForm.use = item.usedFlowRate / 1024;
            this.endTimeForm.pkgId = item.id;
        },
        sureChangePkgEndTimeHandler() {
            if (this.endTimeForm.type == 1) {
                var data = {
                    simPkgId: this.endTimeForm.pkgId,
                    newTimeString: this.endTimeForm.newTimeString,
                    remark: this.endTimeForm.remark,
                    newEndString: this.endTimeForm.newEndString
                }
                changePkgEndTime(data).then(res => {
                    if (res.data.code == 200) {
                        this.endTimeVisible = false;
                        this.$message.success('变更过期时间完成！');
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else if (res.data.code == 400) {
                        this.$message.error(res.data.message);
                    }
                })
            } else {
                var dataP = {
                    simPkgId: this.endTimeForm.pkgId,
                    dayNum: this.endTimeForm.dayNum,
                    remark: this.endTimeForm.remark
                }
                delayPkgEndTime(dataP).then(res => {
                    if (res.data.code == 200) {
                        this.endTimeVisible = false;
                        this.$message.success('变更过期时间完成！');
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else if (res.data.code == 400) {
                        this.$message.error(res.data.message);
                    }
                })
            }
        },
        sureChangePkgEndTimeHandler1() {
            var dataP = {
                id: this.endTimeForm.pkgId,
                flowRate: this.endTimeForm.total,
                usedFlowRate: this.endTimeForm.use
            }
            delayPkgEndTime1(dataP).then(res => {
                if (res.data.code == 200) {
                    this.endTimeVisible1 = false;
                    this.$message.success('修改流量信息完成！');
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                } else if (res.data.code == 400) {
                    this.$message.error(res.data.message);
                }
            })

        },
        showAddPkg() {
            var data = {
                iccid: this.cardInfo.iccid
            }
            getPkgList(data).then(res => {
                var result = res.data.data;
                if (res.data.code == 200) {
                    if (result.length > 0) {
                        this.addPkgVisible = true;
                        this.pkgList = result;
                    } else {
                        this.$message.error('该套餐组下无可添加的套餐！')
                    }
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        sureAddPkgHandle() {
            this.$refs.addPkgForm.validate(valid => {
                if (valid) {
                    var data = this.addPkgForm;
                    data.iccid = this.cardInfo.iccid
                    addPkg(data).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.addPkgVisible = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        stopSimHandler() {
            this.$confirm("您确定要进行停机操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                stopSim(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("停机完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        if (res.data) {
                            this.$message.error(res.data.message);
                        }
                    }
                })
            })
        },
        resetSimHandler() {
            this.$confirm("您确定要进行复机操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                resetSim(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("复机完成！")
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            })
        },
        showChangePkgGoupHandler() {
            this.changePkgGroupVisible = true;
            var data = {
                basePkgGroup: this.cardInfo.basePkgGroup,
                iccid: this.cardInfo.iccid
            }
            getAllowChangePkgGroup(data).then(res => {
                if (res.data.code == 200) {
                    this.allowPkgGroup = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        sureChangePkgGroupHandler() {
            var data = {
                basePkgGroup: this.pkgGroupForm.newPkgGroup,
                iccid: this.cardInfo.iccid,
                remark: this.pkgGroupForm.remark
            }
            toChangePkgGroup(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('变更套餐成功！');
                    this.changePkgGroupVisible = false;
                    this.getSimDetailInfoHandler(this.cardInfo.iccid)
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showToNewCardHandler() {
            this.toNewCardVisible = true;
        },
        sureToNewCardHandler() {
            this.$refs.toNewCardForm.validate(valid => {
                if (valid) {
                    var data = {
                        oldIccid: this.cardInfo.iccid,
                        newIccid: this.toNewCardForm.iccid,
                        moveType: this.toNewCardForm.moveType,
                        remark: this.toNewCardForm.remark
                    }
                    toNewCard(data).then(res => {
                        if (res.data.code == 200) {
                            this.toNewCardVisible = false;
                            this.$message.success('转卡成功！');
                            this.getSimDetailInfoHandler(this.cardInfo.iccid)
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        simDiagnosisHandler() {
            this.$confirm("您确定使用一键诊断功能吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                simDiagnosis(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("诊断完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },
        stateRecordListHandler() {
            this.stateRecordVisible = true;
            var data = {
                perPageNum: this.pageSize_record,
                pageNo: this.currentPage_record,
                iccid: this.cardInfo.iccid
            }
            getSimStopStartRecordList(data).then(res => {
                if (res.data.code == 200) {
                    var result = res.data.data;
                    this.tableData_record = result.resultList;
                    this.total_record = result.totalNum;
                    this.currentPage_record = result.pageNo;
                    this.pageSize_record = result.perPageNum;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        getFluxDetailListHandler() {
            this.fluxVisible = true;
            var data = {
                perPageNum: this.pageSize_flux,
                pageNo: this.currentPage_flux,
                simId: this.cardInfo.id
            }
            getFluxDetailList(data).then(res => {
                if (res.data.code == 200) {
                    var result = res.data.data;
                    this.tableData_flux = result.resultList;
                    this.total_flux = result.totalNum;
                    this.currentPage_flux = result.pageNo;
                    this.pageSize_flux = result.perPageNum;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showChangeCardStateHandler() {
            common.sysRequest('sim/state/dict', {}, 'get').then(res => {
                if (res.data.code == 200) {
                    this.cardStateOption = res.data.data;
                    this.changeStateVisible = true;
                } else {
                    this.$message.error(res.data.message);
                }
            })

        },
        sureChangeStateHandler() {
            this.$refs.changeStateForm.validate(valid => {
                if (valid) {

                    var data = this.changeStateForm;
                    data.id = this.cardInfo.id;
                    changeCardState(data).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.getSimDetailInfoHandler(this.cardInfo.iccid)
                            this.changeStateVisible = false;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        //跳转至【流量轮询详情】页面
        toFluxPollDetail(iccid) {
            localStorage.setItem('pkGIccid', iccid);
            this.$store.commit('menu/setFluxPollDetailIccid', iccid);
            this.$store.commit('menu/setFluxPollDetailTaskNo', "");
            if (!this.$store.state.menu.isFluxPollDetailTab) {
                let newTab = {
                    label: '套餐使用详情',
                    index: 'fluxPollDetail',
                    closable: true,
                    component: "views/monitor/fluxPollDetail"
                }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsFluxPollDetailTab', true);
            }
            this.$store.commit('menu/switchTab', 'fluxPollDetail')
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getOneSIMOrderListHandler();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getOneSIMOrderListHandler();
        },
        handleSizeChangeRecord(val) {
            this.pageSize_record = val;
            this.stateRecordListHandler();
        },
        handleCurrentChangeRecord(val) {
            this.currentPage_record = val;
            this.stateRecordListHandler();
        },
        handleSizeChangeFlux(val) {
            this.pageSize_flux = val;
            this.getFluxDetailListHandler();
        },
        handleCurrentChangeFlux(val) {
            this.currentPage_flux = val;
            this.getFluxDetailListHandler();
        }, showOrderDetailHandler(row) {//查看订单详情
            this.orderDetailVisible = true;
            this.orderDetailForm = row;
            return;
        }, modifyOrderInfoHandler(row) {//修改订单备注 
            if (row.remark.length == '') {
                return;
            }
            let param = {
                id: row.id,
                remark: row.remark
            }
            modifyOrderRemark(param).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);

                } else {
                    this.$message.error(res.data.message);
                }
            });

        },
        showAddOverlayPkg() {
            this.overlayPkgVisible = true;
            getOverlayPkgOptions({}).then(res => {
                if (res.data.code == 200) {
                    this.overlayPkgGroup = res.data.data;
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        changeHandler() {
            this.overlayPkgForm.packageId = '';
            var data = {
                typeGroupId: this.overlayPkgForm.typeGroupId
            }
            common.getPkgOfGroupCom(this, 'overlayPkgList', data);
        },
        IllusoryCardState(row) {
            if (row.cardState >= 5 && row.cardState != 11) {//异常或违禁
                if (row.cardState == 12) {
                    return '注销'
                } else if (row.cardState == 9) {
                    return '故障'
                }
                return '正常';
            } else {
                return row.cardStateName;
            }
        },
        sureAddOverlayPkg() {
            this.$refs.overlayPkgForm.validate(valid => {
                if (valid) {
                    var data = this.overlayPkgForm;
                    data.iccid = this.cardInfo.iccid
                    addPkg(data).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.overlayPkgVisible = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },

        isExpiredTime(str) {
            let d = new Date(str);
            if (d < new Date()) {
                return true;
            }
            return false;
        },
        showAddRealNameSearch() {//点击电信实名查询
            let data = {
                iccid: this.cardInfo.iccid,
                intoNo: this.cardInfo.intoNo
            }
            getRealName(data).then(res => {
                if (res.data.code == 200) {
                    this.$alert('已实名', {
                        confirmButtonText: '确定'
                    })
                } else {
                    this.$alert('未实名', {
                        confirmButtonText: '确定'
                    })
                }
            })
        },
        //重置流量
        resetFlow() {
            this.$confirm('此功能仅供用户流量套餐异常时操作，不支持跨月套餐，确定要重置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let param = {
                    id: this.cardInfo.id,
                    iccid: this.cardInfo.iccid
                }

                common.sysRequest('pkg/update/pkg', param, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            }).catch(() => { });
        },
    },
    created() {

    },
    mounted() {
        let fromPage = this.$store.state.menu.fromPage;
        let fromPageIccid = this.$store.state.menu.fromPageIccid;
        if (fromPage == 'cardMgt' || fromPage == 'orderMgt') {
            this.cardDetailsForm.iccid = fromPageIccid;
            this.getSimDetailInfoHandler(this.cardDetailsForm.iccid);
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageIccid', '');
        }
    },

    computed: {
        getSum: function () {
            let sum = 0;
            for (let i = 0; i < this.cardInfo.simPackageList.length; i++) {
                sum += Number(this.fluxMtoG(this.cardInfo.simPackageList[i].usedRealFlowRate));
            }
            return this.money_format(sum, 2);
        },
        visiblePackageList() {
            if (this.isPackageFold && this.cardInfo.simPackageList.length > 4) {
                return this.cardInfo.simPackageList.slice(0, 4);
            }
            return this.cardInfo.simPackageList;
        }
    },
}
</script>

<style lang="less">
#cardDetails {
    font-size: 12px;

    .section1,
    .section2,
    .section3,
    .section4,
    .section5 {
        margin-bottom: 30px;
        padding-left: 8px;
    }

    .section2 {
        .el-row {
            line-height: 40px;
        }
    }

    .section3 {
        .el-row {
            line-height: 34px;
            margin-bottom: 20px;
        }

        .progressOuter {
            line-height: normal;

            .el-progress {
                margin: 5px 0;
            }
        }

        .pOuter {
            margin-top: -10px;
        }
    }

    .section4 {
        div {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .el-button {
                flex: 1;
                margin-bottom: 10px;
            }
        }
    }

    h4 {
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin-bottom: 20px;
        margin-left: -8px;
        border-left: 3px solid #409eff;
    }

    /*新增套餐*/
    .pkgName {
        display: block;

        label.el-radio {
            width: 50%;
            margin: 10px 0 15px 0;
        }
    }

    .span-defined {
        margin-right: 20px;
    }

    .span-data {
        text-align: center;
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        width: 100%;
        display: flex;
        justify-content: center;

        div {
            margin-right: 13px;
        }
    }

    .font-defined {
        font-size: 24px;
    }

    .green {
        color: #309200;
    }

    .red {
        color: #c71c1c;
    }

    .dark {
        color: #7d7d5d;
    }

    .text-animation-default {
        animation: text-animation 3s infinite ease-out;
    }

    @keyframes text-animation {
        0% {
            transform: translateY(-30px);
        }

        1.5% {
            transform: translateY(30px);
        }

        3% {
            transform: translateY(-30px);
        }

        4.5% {
            transform: translateY(30px);
        }

        6% {
            transform: translateY(-30px);
        }

        7.5% {
            transform: translateY(30px);
        }

        9% {
            transform: translateY(-30px);
        }

        10.5% {
            transform: translateY(30px);
        }

        12% {
            transform: translateY(-30px);
        }

        13.5% {
            transform: translateY(30px);
        }

        15% {
            transform: translateY(-30px);
        }

        50% {
            transform: scale(1.6) translateY(30px);
        }

        100% {
            transform: scale(1.6) translateY(30px);
        }
    }
}












/* 设备详情弹窗样式 */
.device-detail-dialog {
    --primary-color: #409eff;
}

.device-detail-dialog .detail-wrapper {
    padding: 10px;
}

/* 卡片样式 */
.device-detail-dialog .detail-card {
    background: #fafbfc;
    border: 1px solid #e4e7ed;
    border-radius: 12px;
    padding: 18px 22px;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* 卡片标题 */
.device-detail-dialog .card-title {
    font-size: 15px;
    font-weight: bold;
    color: #333;
    margin: 0 0 14px 0;
    display: flex;
    align-items: center;
    gap: 6px;
}

.device-detail-dialog .card-title i {
    color: var(--primary-color);
    font-size: 16px;
}

/* 字段样式 */
.device-detail-dialog .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 10px 12px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    margin-bottom: 10px;
}

.device-detail-dialog .field label {
    font-size: 12px;
    color: #909399;
    font-weight: 400;
}

.device-detail-dialog .field span {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    min-height: 20px;
}

/* 按钮居右 */
.device-detail-dialog .dialog-footer {
    text-align: right;
    padding: 10px 0 0;
}

.device-dialog-height {
    max-height: 80vh;
    /* 占屏幕高度的80%，不会超大 */
    display: flex;
    flex-direction: column;
}

.device-dialog-height .el-dialog__body {
    flex: 1;
    overflow-y: auto;
    /* 自动滚动 */
    padding-bottom: 10px;
}
</style>
